// keys
export const DEFAULT = 'div';
export const TITLE = 'title';
export const LIST = 'list';
export const IMAGE = 'image';
export const IMAGES = 'images';
export const TEXT = 'text';
export const BUTTONS = 'buttons';
export const REWARD = 'reward';
export const HEADER = 'header';
export const USER_BILLET = 'userBillet';
export const CLOSE = 'close';
